import { render } from "./MatchingRetrievalSummary.vue?vue&type=template&id=1df0f442&scoped=true&ts=true&lang=pug"
import script from "./MatchingRetrievalSummary.vue?vue&type=script&lang=ts"
export * from "./MatchingRetrievalSummary.vue?vue&type=script&lang=ts"

import "./MatchingRetrievalSummary.vue?vue&type=style&index=0&id=1df0f442&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df0f442"]])

export default __exports__